import React from 'react';

// Advent supports two IRR calculation methods on the money-weighted report
// family. Average Capital Base is the house default (every existing GT pin is
// on it); Discounted Cash Flow is the iterative dollar-weighted solve. The
// popups omit the param when the default is selected so default payloads stay
// byte-identical to before this option existed.
export const IRR_METHOD_OPTIONS = [
  { value: 'average_capital', label: 'Average Capital' },
  { value: 'dcf', label: 'Discounted Cash Flow' },
];

export const DEFAULT_IRR_METHOD = 'average_capital';

const IrrMethodField = ({ value, onChange, darkMode = false, disabled = false }) => (
  <div>
    <label
      htmlFor="irr-method-select"
      className={`block text-sm font-medium mb-1 ${
        darkMode ? 'text-gray-300' : 'text-gray-700'
      }`}
    >
      IRR Calculation Method
    </label>
    <select
      id="irr-method-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`w-full px-3 py-2 rounded-lg border ${
        darkMode
          ? 'bg-[#1a1a1a] border-white/10 text-white'
          : 'bg-white border-gray-300 text-gray-900'
      } focus:outline-none focus:ring-2 focus:ring-gray-500`}
      disabled={disabled}
    >
      {IRR_METHOD_OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </div>
);

export default IrrMethodField;
